module.exports = __webpack_public_path__ + "img/icon-app-lightning.7dd404dd.svg";